import { List } from 'immutable';
export const onReportResolvePayloadConfigReport = ({
  report,
  dataset
}) => {
  const hasData = dataset.get('hasData') || dataset.keySeq().filter(datasetKey => datasetKey !== 'summary' && !dataset.getIn([datasetKey, 'data', 'data'], List()).isEmpty()).count() > 0;
  return {
    configured: report,
    data: dataset,
    hasData
  };
};